/**
 * 日期工具函数
 */

/**
 * 判断当前时间是否在指定的日期范围内
 * @param {string} startDate - 开始日期 (YYYY-MM-DD格式)
 * @param {string} endDate - 结束日期 (YYYY-MM-DD格式)
 * @returns {boolean} - 当前时间是否在范围内
 */
export function isCurrentTimeInRange(startDate, endDate) {
  if (!startDate || !endDate) {
    return false;
  }

  const currentDate = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  // 检查日期是否有效
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return false;
  }

  // 设置时间为当天的00:00:00和23:59:59
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);

  return currentDate >= start && currentDate <= end;
}

/**
 * 格式化日期为MM/DD格式
 * @param {string} dateString - 日期字符串
 * @returns {string} - 格式化后的日期
 */
export function formatDateToMMDD(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
}
